export default __webpack_public_path__ + "static/media/pie-chart.95632378.svg";